module.exports = __webpack_public_path__ + "static/what-we-do-banner-image-d6354e9a478c04f4ec013dca3a81d509.png";